

export var DefaultProps = {
  iconColor: 'inherit',
  textColor: 'currentColor',
  iconGradientStart: 'inherit',
  iconGradientStop: 'inherit',
  size: 'medium'
};


export var sizes = {
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 40,
  xlarge: 48
};